import { Container } from '@mui/material';
import React from 'react';

const CenteredContent: React.FC = ({children}) => {
    return <Container maxWidth="md">
        { children }
    </Container>
}

export default CenteredContent;